import React, { useState, useEffect } from 'react';
import { GetParentTreeApi } from "../../../api/request/users";
import { useSearchParams } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Table } from 'antd';
const colors = [
    '#539198',
    '#c04e4e',
    '#c79f34',
    '#656d37',
    '#a1bdbe',
    '#ccc5c5',
    '#af3429',
];

const getColor = (level) => {
    const colorIndex = (level - 1) % colors.length;
    let color
    if (level == 0) {
        color = '#da856c'
    } else {
        color = colors[colorIndex];
    }
    return color;
}
const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        render: (_, record) => (<p className='f-bold' style={{ color: getColor(record?.level),fontWeight:'bold',fontSize:16 }} >{record?.name}</p>)
    },
    {
        title: 'Level',
        dataIndex: 'level',
    },
    {
        title: 'Count',
        dataIndex: 'count',
    },
    {
        title: 'Email',
        dataIndex: 'email',
    },
    // {
    //     title: 'Mobile No',
    //     dataIndex: 'mobileNo',
    // },
];
function ParentTree() {
    const { userDetails } = useSelector(state => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [treeData, setTreeData] = useState();
    const [searchParams] = useSearchParams();
    const { id } = useParams();
    const [data, setData] = useState();
    const openUserDetails = (selectedUser) => {
        const win = window.open(`/ib_tree_user/${selectedUser}`, "_blank");
        win.focus();
    }

    // const convertDataToTree = (data) => {
    //     const traverse = (node) => {
    //         return {
    //             name:node?.fullName,
    //             level:node?.level || 0,
    //             key: `${node?.userId}`,
    //             count:node?.userCount || 0,
    //             email:node?.email,
    //             MobileNo:node?.mobile,
    //             children: node.childrenUser.length ? node.childrenUser.map(traverse) : null,
    //         };
    //     };
    //     return [traverse(data)];
    // };
    const convertDataToTree = (data) => {
        return [{
            name: data?.fullName,
            level: data?.level || 0,
            key: `${data?.userId}`,
            count: data?.userCount || 0,
            email: data?.email,
            mobileNo: data?.phoneNo ? data?.phoneNo : '--',
            children: data.childrenUser?.map((child) => ({
                name: child?.fullName,
                level: child?.level || 0,
                key: `${child?.userId}`,
                count: child?.userCount || 0,
                email: child?.email,
                mobileNo: child?.phoneNo ? child?.phoneNo : '--',
                children: null,
            })) || null,
        }];
    };

    const getAllTrader = async () => {
        try {
          setIsLoading(true);
         
          const { data } = await GetParentTreeApi(userDetails?._id);
          if (data?.success) {
            setData(JSON.parse(data?.data));
            setTreeData(convertDataToTree(JSON.parse(data?.data)));
          }
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
        }
      }

      useEffect(() => {
        getAllTrader();
    }, []);
    
    return (
    <div>
            <div className='react-tree-wrapper'>
                <div className='react-flow-container p-4'>
                    {isLoading ? (
                        <div className='text-center text-muted'> Loading...</div>
                    ) : (
                        <div className='m-3'>
                            {
                                data?.childrenUser?.length ? (
                                    
                                    <>
                                        <Table columns={columns} dataSource={treeData} pagination={false}>
                                        </Table>
                                    </>
                                ) : (
                                    <>
                                        <Table columns={columns} dataSource={treeData} pagination={false}>
                                        </Table>
                                    </>
                                )
                            }
                        </div>
                    )}
                </div>
            </div>
            
            </div>
    )
}

export default ParentTree;
